/* Mobile catalog preference only. Does not mutate cart, URLs, filters or product data. */
(() => {
  if (window.rudcaCatalogView) return;
  window.rudcaCatalogView = true;
  const config = document.currentScript?.dataset || {};
  const storageKey = 'rudca:catalog-view:v1';
  const modes = ['grid3', 'grid2', 'list'];
  const mobile = window.matchMedia('(max-width: 640px)');
  const roots = '[data-section-type="collection"], .rudca-origin-browser';
  const states = new WeakMap();
  const priceRows = new WeakMap();
  let queued = false;
  let preference;
  let unsavedPreference = document.documentElement.dataset.rudcaCatalogEarlyChoiceUnsaved === 'true';
  delete document.documentElement.dataset.rudcaCatalogEarlyChoiceUnsaved;
  try { preference = localStorage.getItem(storageKey); } catch (_) {}
  const earlyChoice = document.documentElement.dataset.rudcaCatalogEarlyChoice;
  if (modes.includes(earlyChoice)) preference = earlyChoice;
  delete document.documentElement.dataset.rudcaCatalogEarlyChoice;
  if (preference === 'grid') preference = 'grid2';
  if (!modes.includes(preference)) preference = document.documentElement.dataset.rudcaCatalogInitialView;
  if (!modes.includes(preference)) preference = config.legacyLayout === 'list' ? 'list' : 'grid3';
  const labels = { grid: config.gridLabel || 'Grid', list: config.listLabel || 'List' };
  const svgNS = 'http://www.w3.org/2000/svg';
  function icon(mode) {
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24'); svg.setAttribute('height', '24');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    if (mode === 'list') {
      for (const y of [5, 12, 19]) {
        const line = document.createElementNS(svgNS, 'path');
        line.setAttribute('d', `M4 ${y}h16`); line.setAttribute('stroke', 'currentColor');
        line.setAttribute('stroke-width', '2'); line.setAttribute('stroke-linecap', 'round'); svg.appendChild(line);
      }
    } else {
      const xs = mode === 'grid2' ? [8, 16] : [5, 12, 19];
      for (const y of [5, 12, 19]) for (const x of xs) {
        const dot = document.createElementNS(svgNS, 'circle');
        dot.setAttribute('cx', String(x)); dot.setAttribute('cy', String(y));
        dot.setAttribute('r', '2'); dot.setAttribute('fill', 'currentColor'); svg.appendChild(dot);
      }
    }
    return svg;
  }
  function controls() {
    const group = document.createElement('div');
    group.className = 'rudca-catalog-view-controls';
    group.setAttribute('role', 'group'); group.setAttribute('aria-label', config.layoutLabel || 'Layout');
    for (const mode of modes) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.rudcaCatalogMode = mode;
      button.className = 'rudca-catalog-view-button';
      button.setAttribute('aria-label', mode === 'list' ? labels.list : `${labels.grid} ${mode === 'grid2' ? '2' : '3'}`);
      button.appendChild(icon(mode)); group.appendChild(button);
    }
    return group;
  }
  function nativeButtons(root) { return [...root.querySelectorAll('[data-action="change-layout"]')]; }
  function setNative(root, mode) {
    for (const button of nativeButtons(root)) {
      const selected = button.dataset.layoutMode === (mode === 'list' ? 'list' : 'grid');
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    }
  }
  // Adapt only legacy server-list markup; never remount its external review widget.
  function adaptPriceRow(card, compact) {
    const existing = priceRows.get(card);
    if (!compact) {
      if (!existing) return;
      const { price, review, priceAnchor, wrapper, reviewHidden } = existing;
      if (priceAnchor.parentNode) priceAnchor.replaceWith(price);
      review.hidden = reviewHidden;
      review.removeAttribute('data-rudca-catalog-review-replaced');
      card.removeAttribute('data-rudca-catalog-price-adapted');
      wrapper.remove(); priceRows.delete(card);
      return;
    }
    if (existing || card.querySelector('.rudca-card-price-rating')) return;
    const price = card.querySelector('.product-item__info-inner > .rudca-card-price-list');
    const review = card.querySelector('.product-item__info > .rudca-card-reviews');
    if (!price || !review) return;
    const priceAnchor = document.createComment('rudca-price-position');
    price.before(priceAnchor);
    const wrapper = document.createElement('div');
    wrapper.className = 'rudca-card-price-rating';
    wrapper.setAttribute('data-rudca-adapted-price-row', '');
    price.before(wrapper); wrapper.append(price);
    card.setAttribute('data-rudca-catalog-price-adapted', '');
    const reviewHidden = review.hidden;
    const parts = (review.querySelector('ryviu-widget-total')?.getAttribute('reviews_data') || '').split(';');
    const countText = (parts[0] || '').trim();
    const ratingText = (parts[1] || '').trim();
    const count = Number(countText), rating = Number(ratingText);
    let productURL;
    try { productURL = new URL(card.querySelector('.product-item__title')?.getAttribute('href'), location.href); } catch (_) {}
    if (!reviewHidden && /^\d+$/.test(countText) && /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(ratingText) && Number.isSafeInteger(count) && count > 0 && rating >= 1 && rating <= 5 && productURL?.origin === location.origin && productURL.pathname.includes('/products/')) {
      const link = document.createElement('a');
      link.className = 'rudca-card-rating link'; productURL.hash = 'product-reviews'; link.href = productURL.href;
      link.setAttribute('aria-label', (config.ratingLabel || 'Rated [rating] out of 5 from [count] reviews').replaceAll('[rating]', String(rating)).replaceAll('[count]', String(count)));
      const star = document.createElement('span'); star.className = 'rudca-card-rating__star'; star.setAttribute('aria-hidden', 'true'); star.textContent = '★';
      const value = document.createElement('span'); value.setAttribute('aria-hidden', 'true'); value.textContent = `${Math.round(rating * 10) / 10} (${count})`;
      link.append(star, value); wrapper.append(link);
      review.hidden = true; review.setAttribute('data-rudca-catalog-review-replaced', '');
    }
    priceRows.set(card, { price, review, priceAnchor, wrapper, reviewHidden });
  }
  function apply(root) {
    const grid = root.querySelector('.product-list--collection, [data-origin-grid]');
    if (!grid) return;
    let state = states.get(root);
    if (!state) {
      state = { desktopMode: root.querySelector('[data-action="change-layout"].is-selected')?.dataset.layoutMode || (grid.querySelector('.product-item')?.classList.contains('product-item--list') ? 'list' : 'grid'), mobileApplied: false };
      states.set(root, state);
    }
    grid.setAttribute('data-rudca-catalog-grid', '');
    const native = root.querySelector('.rudca-polish-layout, .collection__toolbar-item--layout');
    if (native) native.setAttribute('data-rudca-native-layout', '');
    let group = root.querySelector('.rudca-catalog-view-controls');
    if (!group) {
      group = controls();
      if (native) native.after(group); else grid.before(group);
    }
    group.hidden = !mobile.matches;
    if (!mobile.matches) {
      if (state.mobileApplied) {
        setNative(root, state.desktopMode);
        for (const card of grid.querySelectorAll('.product-item:not([data-photo-control])')) {
          adaptPriceRow(card, false);
          card.classList.toggle('product-item--list', state.desktopMode === 'list');
          card.classList.toggle('product-item--vertical', state.desktopMode !== 'list');
        }
        state.mobileApplied = false;
      }
      root.removeAttribute('data-rudca-catalog-view');
      return;
    }
    state.mobileApplied = true;
    root.dataset.rudcaCatalogView = preference;
    setNative(root, preference);
    for (const button of group.querySelectorAll('[data-rudca-catalog-mode]')) {
      const selected = button.dataset.rudcaCatalogMode === preference;
      button.classList.toggle('is-selected', selected); button.setAttribute('aria-pressed', String(selected));
    }
    for (const card of grid.querySelectorAll('.product-item:not([data-photo-control])')) {
      adaptPriceRow(card, preference !== 'list');
      card.classList.toggle('product-item--list', preference === 'list');
      card.classList.toggle('product-item--vertical', preference !== 'list');
    }
  }
  function refresh() { queued = false; document.documentElement.dataset.rudcaCatalogInitialView = preference; document.querySelectorAll(roots).forEach(apply); }
  function restorePreference() {
    if (unsavedPreference) { schedule(); return; }
    try {
      const saved = localStorage.getItem(storageKey);
      if (modes.includes(saved)) preference = saved;
      else if (saved === 'grid') preference = 'grid2';
    } catch (_) {}
    schedule();
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(refresh); } }
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-rudca-catalog-mode]');
    if (button && mobile.matches && modes.includes(button.dataset.rudcaCatalogMode)) {
      event.preventDefault(); preference = button.dataset.rudcaCatalogMode;
      try { localStorage.setItem(storageKey, preference); unsavedPreference = false; } catch (_) { unsavedPreference = true; }
      refresh(); return;
    }
    const native = event.target.closest?.('[data-action="change-layout"]');
    if (native && !mobile.matches) {
      const root = native.closest(roots); const state = root && states.get(root);
      if (state) state.desktopMode = native.dataset.layoutMode;
    }
  });
  function start() {
    refresh();
    new MutationObserver((records) => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && !node.matches('.rudca-catalog-view-controls')))) schedule();
    }).observe(document.body, { subtree: true, childList: true });
    mobile.addEventListener('change', schedule);
    window.addEventListener('pageshow', restorePreference);
    window.addEventListener('popstate', restorePreference);
    window.addEventListener('storage', (event) => { if (event.key === storageKey) restorePreference(); });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('rudca:products-appended', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
